import * as Immutable from "immutable";
import { validateJSON, validateXML } from "services/payload-validators";
import BaseMessageRecord from "../BaseMessageRecord";

function isTextValid(type: string, text: string): boolean {
  return type === "json" ? validateJSON(text) : validateXML(text);
}

export const httpMessageRecordDefaultAttributes = {
  type: "http_request_recipe",
  headers: Immutable.OrderedMap({ "": "" }),
  headersList: Immutable.List(),
  errorResponseId: null as string,
  errorResponse: true,
  isHandoff: false,
  requestUrl: "",
  requestPayload: "",
  requestPayloadType: "json",
  requestType: "GET",
  httpResponse: Immutable.Map({}),
  httpResponseLoading: false,
  variablesData: Immutable.List()
};

class HTTPMessageRecord extends BaseMessageRecord(httpMessageRecordDefaultAttributes) {}

/**
 * Validation
 */

export function getInvalidHttpFields(message: HTTPMessageRecord): Immutable.List<string> {
  const invalidFields: Set<string> = new Set();

  const isXML = message.requestPayloadType === "data";

  message.variablesData
    .filter(data => !data.get("variableId"))
    .forEach((data, i) => invalidFields.add(`invalidVariableId-${i}`));

  if (message.requestUrl.length <= 0) {
    invalidFields.add("requestUrl");
  }

  if (
    isXML && ["PUT", "PATCH", "POST"].includes(message.requestType) &&
    !isTextValid(
      "data",
      message.get("requestPayload")
    )
  ) {
    invalidFields.add("requestPayload");
  }

  if (message.errorResponse && !message.errorResponseId) {
    invalidFields.add("errorResponse");
  }

  return Immutable.List(invalidFields);
}

HTTPMessageRecord.getInvalidFields = getInvalidHttpFields;

export default HTTPMessageRecord;
